import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {BusinessTypeService} from 'app/blocks/service/api/business-type.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IBusinessType, BusinessType} from 'app/blocks/model/business-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class BusinessTypeResource extends AbstractEntityResource<IBusinessType> {
    constructor(businessTypeService: BusinessTypeService, router: Router) {
        super(
            Resource.BUSINESS_TYPES,
            businessTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.BUSINESS_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.BUSINESS_TYPES),
            (entity?) => new BusinessType(entity),
            (entity) => entity.id,
            faStar
        );
    }
}
